export const MODE_ACTIVE = 'active'
export const MODE_BED = 'bed'
export const MODE_AUTO = 'auto'

// 對應後端 SaveMonthlyReportCommentRequest::TEXT_MAX_LENGTH
export const COMMENT_TEXT_MAX_LENGTH = 2000

export const COMMENT_STATUS_VARIANTS = {
  none: 'secondary',
  draft: 'warning',
  published: 'success'
}

// 分數 1～3：1 待加強、2 普通、3 良好
const SCORE_META = {
  1: { variant: 'danger', labelKey: '__monthlyReport.scoreBad' },
  2: { variant: 'warning', labelKey: '__monthlyReport.scoreFair' },
  3: { variant: 'success', labelKey: '__monthlyReport.scoreGood' }
}

export const CHART_TITLE_KEYS = {
  [MODE_ACTIVE]: ['__monthlyReport.activeChart1', '__monthlyReport.activeChart2', '__monthlyReport.activeChart3'],
  [MODE_BED]: ['__monthlyReport.bedChart1', '__monthlyReport.bedChart2', '__monthlyReport.bedChart3']
}

const HOURS_PER_DAY = 24
export const MINUTES_PER_HOUR = 60

export function scoreMeta (score) {
  return SCORE_META[score] || null
}

// 作息燈號只屬於離床版、臥床照顧只屬於臥床版；mode 未定時兩者都列
export function indicatorKeys (mode) {
  const keys = ['respiration']
  if (mode !== MODE_BED) keys.push('routine')
  if (mode !== MODE_ACTIVE) keys.push('care')
  keys.push('rest')
  return keys
}

export function formatNumber (value, digits = 1) {
  if (value === null || value === undefined || value === '') return '-'
  const number = Number(value)
  return Number.isFinite(number) ? number.toFixed(digits) : '-'
}

// avg_asleep_start_hour 凌晨會加 24（例 25.5 = 01:30）
export function formatClockHour (value) {
  if (value === null || value === undefined || value === '') return '-'
  const hour = Number(value)
  if (!Number.isFinite(hour)) return '-'
  const totalMinutes = Math.round((hour % HOURS_PER_DAY) * MINUTES_PER_HOUR)
  const hh = Math.floor(totalMinutes / MINUTES_PER_HOUR) % HOURS_PER_DAY
  const mm = totalMinutes % MINUTES_PER_HOUR
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
}

// 對應後端 timeline API 每格的狀態值，順序即圖例順序
export const TIMELINE_STATUS_NONE = 'none'
export const TIMELINE_STATUSES = ['leave', 'lying', 'sleep', TIMELINE_STATUS_NONE]
export const TIMELINE_SLOT_MINUTES = 30

const MINUTES_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR

function padTwo (value) {
  return String(value).padStart(2, '0')
}

// dateTime 格式為 "YYYY-MM-DD HH:mm"，解析失敗回 null
function parseDateTime (dateTime) {
  const match = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})/.exec(dateTime || '')
  if (!match) return null
  return {
    month: Number(match[2]),
    day: Number(match[3]),
    minutesOfDay: Number(match[4]) * MINUTES_PER_HOUR + Number(match[5])
  }
}

export function formatMinutesOfDay (minutes) {
  const normalized = ((minutes % MINUTES_PER_DAY) + MINUTES_PER_DAY) % MINUTES_PER_DAY
  return `${padTwo(Math.floor(normalized / MINUTES_PER_HOUR))}:${padTwo(normalized % MINUTES_PER_HOUR)}`
}

function formatShortDateTime (dateTime) {
  const parsed = parseDateTime(dateTime)
  if (!parsed) return dateTime || '-'
  return `${parsed.month}/${parsed.day} ${formatMinutesOfDay(parsed.minutesOfDay)}`
}

export function formatWindowLabel (start, end) {
  return `${formatShortDateTime(start)} - ${formatShortDateTime(end)}`
}

export function windowStartMinutes (start) {
  const parsed = parseDateTime(start)
  return parsed ? parsed.minutesOfDay : null
}

export function hasTimelineData (windows) {
  return (windows || []).some(item => (item.slots || []).some(status => status && status !== TIMELINE_STATUS_NONE))
}

export function emptyCommentForm () {
  return {
    summary: '',
    respiration: '',
    chart_1: '',
    chart_2: '',
    chart_3: '',
    trend_status: null,
    trend_summary: ''
  }
}

export function commentToForm (comment) {
  const form = emptyCommentForm()
  if (!comment) return form
  Object.keys(form).forEach(key => {
    if (comment[key] !== null && comment[key] !== undefined) form[key] = comment[key]
  })
  return form
}
